import { useEffect, useState } from "react";
import { instanceMob, Loadingspinner } from "../../../../utils/utils";
import changePage from "../../functions/changePage";
import TableCustomAdministrative from "./table-custom-administrative";
import ComponentSelectFrecuency from "./component-select-frecuency";
import ConfirmDeletionModal from "../modal-delete";
import moment from "moment";
import { formatMoney } from "./graphics/simple-bar-chart.tsx";

const PanelLeftAdministrativeHistory = (props) => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [pageNext, setPageNext] = useState(false);
  const [pageBack, setPageBack] = useState(false);
  const [dataBackup, setDataBackup] = useState({});
  const [frecuency, setFrecuency] = useState("");
  const [usersList, setUsersList] = useState([]);
  const [modalError, setModalError] = useState(null);
  const [customerInfo, setCustomerInfo] = useState(null);

  async function getUsersList(searchTerm = "") {
    let filtered = searchTerm.length > 0 ? `?search=${searchTerm}` : "";

    try {
      const response = await instanceMob.get(`admin/customers${filtered}`);
      const data = response?.data || [];
      const data_new = data?.map((ele) => ({
        id: ele.id,
        name: ele.name,
        valor: ele.id,
      }));
      setUsersList(
        [{ id: 0, name: "Seleccionar usuario", valor: "" }].concat(data_new)
      );
    } catch (err) {
      console.error("Error fetching users:", err);
      return []; // Retorna un array vacío en caso de error
    }
  }

  function getUsers(filter = "") {
    let filtered = filter.length > 0 ? `${filter}` : "";
    instanceMob
      .get(`admin/metrics/customer${filtered}`)
      .then((res) => res.data)
      .then((data) => {
        setUsers(data.results);

        setCount(data.count);
        setPageNext(data.next);
        setPageBack(data.previous);
        setDataBackup(data);
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setIsLoading(false);
      });
  }

  function getUsersPage(value) {
    let url = value ? value : `admin/metrics/customer`;
    setIsLoading(true);

    instanceMob
      .get(url)
      .then((res) => res.data)
      .then((data) => {
        setUsers(data.results);
        setPageNext(data.next);
        setPageBack(data.previous);
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setIsLoading(false);
      });
  }

  function queryRes(frecuency) {
    if (frecuency === "") {
      getUsers();
      setPage(1);
      setCount(0);
      setPageNext(false);
      setPageBack(false);
      setCustomerInfo(null);
    } else {
      instanceMob
        .get(`/admin/metrics/customer?customer_id=${frecuency}`)
        .then((res) => {
          if (res.status) {
            const data = res.data;
            setUsers(data.results);

            setCount(data.count);
            setPageNext(data?.next || false);
            setPageBack(data?.previous || false);
            setCustomerInfo(data.customer_info);
          }
        })
        .catch((err) => {
          let msg_error = err.response.data;
          if (msg_error) {
            setModalError(
              <ConfirmDeletionModal
                onCancel={() => setModalError(null)}
                onConfirm={() => setModalError(null)}
                loader={false}
              >
                Algo sucedio, intenta de nuevo
              </ConfirmDeletionModal>
            );
          }
        });
    }
  }

  useEffect(() => {
    queryRes(frecuency);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [frecuency]);

  useEffect(() => {
    getUsersList();
  }, []);

  useEffect(() => {
    setIsLoading(true);
    getUsers();
  }, []);

  return (
    <>
      <div
        style={{
          width: "100%",
          border: "1px solid #B6C1CE",
          borderRadius: "10px",
          height: "100%",
        }}
      >
        <div className="h-100 ">
          <div className="my-2 ">
            <div className="d-flex  p-2" style={{ justifyContent: "center" }}>
              <span
                style={{
                  fontSize: "calc(.4rem + .4vw)",
                  color: "var(--elevvaTextTitle)",
                }}
              >
                <strong>Historial</strong>
              </span>
            </div>
            <div className="d-flex flex-column justify-content-center align-items-center gap-3">
              <div
                className="d-flex mx-4 h-auto "
                style={{
                  width: "50%",
                }}
              >
                <ComponentSelectFrecuency
                  data={usersList}
                  doAction={setFrecuency}
                  defaultData={usersList?.[0] || 0}
                  selectValue={frecuency}
                  onSearchTermChange={(searchTerm) => {
                    if (searchTerm && searchTerm.length > 0) {
                      getUsersList(searchTerm);
                    } else {
                      getUsersList();
                    }
                    setPage(1);
                    setCount(0);
                    setPageNext(false);
                    setPageBack(false);
                  }}
                />
              </div>
              {customerInfo && (
                <div className="d-flex mx-4 mb-1 mt-2 h-auto flex-column align-self-start gap-2">
                  <span className="size-table-users fw-bold">
                    Miembro desde :{" "}
                    {moment(customerInfo.joined_date).format("DD-MMM-YY") ||
                      "----"}
                  </span>
                  <span className="size-table-users fw-bold">
                    Plan más consumido: {customerInfo?.most_used_plan || "---"}
                  </span>

                  <span className="size-table-users fw-bold">
                    Valor consumido a la fecha:{" "}
                    {formatMoney.format(customerInfo?.plan_total_price || 0)}
                  </span>

                  <span className="size-table-users fw-bold text-danger">
                    Total de accesos restantes de la última compra:{" "}
                    {customerInfo?.total_quota || "---"}
                  </span>
                </div>
              )}
            </div>
            {isLoading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "10rem" }}
              >
                <Loadingspinner customStyle="grow" size="2.5rem" />
              </div>
            ) : customerInfo ? (
              <TableCustomAdministrative
                changePage={(value) =>
                  changePage(
                    value,
                    getUsersPage,
                    pageNext,
                    pageBack,
                    page,
                    count,
                    setPage
                  )
                }
                count={count}
                page={page}
                users={users}
              />
            ) : (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "10rem" }}
              >
                <span className="size-table-users">Selecciona un usuario</span>
              </div>
            )}
          </div>
        </div>
      </div>
      {modalError}
    </>
  );
};
export default PanelLeftAdministrativeHistory;
